<template>
  <v-col cols="12">
    <v-card>
      <v-row align="center">
        <v-col cols="8" md="10">
          <v-card-title>{{ shoe.name }}</v-card-title>
        </v-col>
        <v-col>
          <v-card-actions>
            <v-btn
              elevation="2"
              fab
              dark
              small
              @click="editElement(shoe._id)"
              color="blue"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
            <v-btn
              elevation="2"
              fab
              dark
              small
              @click="editMeasures = true"
              color="orange"
            >
              <v-icon>mdi-menu</v-icon>
            </v-btn>
            <v-btn elevation="2" fab dark small @click="delElement" color="red">
              <v-icon>mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog v-model="editMeasures">
      <v-card>
        <EditMeasures
          :value="shoe.measures"
          :id="shoe._id"
          @close="editMeasures = false"
        />
      </v-card>
    </v-dialog>
  </v-col>
</template>

<script>
import EditMeasures from "./EdtiMeasures";
export default {
  name: "Shoe",
  components: { EditMeasures },
  props: ["shoe"],
  data: function() {
    return {
      editMeasures: false
    };
  },
  methods: {
    delElement: async function() {
      const response = await fetch(
        `${process.env.VUE_APP_BACKEND}/shoe/${this.shoe._id}`,
        {
          method: "DELETE"
        }
      );

      console.log(response);

      this.$emit("deleteproduct", this.shoe._id);
    },
    editElement(id) {
      console.log(id);
      this.$router.push(`/edit/${id}`);
    }
  }
};
</script>

<style></style>
